import PaymentsSetup from './PaymentsSetup'

export default PaymentsSetup;